/**
 * GENERATED FILE - DO NOT EDIT BY HAND.
 *
 * Challenger's published adviser rate sheet, turned into data by `scripts/import-annuity-rates.mjs`.
 * To update: save the new sheet over `docs/reference/cll_rates.pdf`, run `npm run rates:import`,
 * run `npm run test:shared`, and commit. Any hand edit here is lost on the next import.
 *
 * WHAT THE NUMBERS ARE.
 *   lifetime.<indexation>.<sex>[age] = [Flexible, Enhanced] yearly payment per $100,000 invested.
 *       Flexible carries a withdrawal period and a death benefit (our "capital returned" shape);
 *       Enhanced carries neither and pays more (our "nil residual" shape).
 *   lifetime.<indexation>.reversionary = the same, for a couple where the income continues to the
 *       survivor. Keyed by the age PAIR the sheet quotes, not by a single age.
 *   carePlus.<sex>[age] = yearly payment per $100,000 of TOTAL money invested, before any adviser
 *       fee, for the annuity-plus-insurance shape that guarantees the whole amount to the estate.
 *   fixedTerm.rcv100 / rcv0 [term] = the earning rate as a PERCENT a year, by payment frequency.
 *
 * Ages the sheet publishes: 60 to 75 for the lifetime shapes, 70 to 100 for the guaranteed shape.
 * `annuityRates.ts` interpolates between them and flags anything it has to extrapolate.
 */

export const ANNUITY_RATES = {
    "source": "Challenger Rates (adviser): Liquid Lifetime, CarePlus, Fixed Term",
    "sourceFile": "cll_rates.pdf",
    "effectiveFrom": "2026-09-21",
    "effectiveTo": "2026-09-27",
    "importedAt": "2026-09-25",
    "lifetime": {
        "noIndexation": {
            "male": {
                "60": [
                    7259,
                    7695
                ],
                "65": [
                    7694,
                    8297
                ],
                "70": [
                    8331,
                    9173
                ],
                "75": [
                    9324,
                    10492
                ]
            },
            "female": {
                "60": [
                    7084,
                    7341
                ],
                "65": [
                    7473,
                    7820
                ],
                "70": [
                    8023,
                    8541
                ],
                "75": [
                    8863,
                    9681
                ]
            },
            "reversionary": [
                {
                    "maleAge": 65,
                    "femaleAge": 60,
                    "flexible": 7060,
                    "enhanced": 7079
                },
                {
                    "maleAge": 65,
                    "femaleAge": 65,
                    "flexible": 7290,
                    "enhanced": 7324
                },
                {
                    "maleAge": 70,
                    "femaleAge": 65,
                    "flexible": 7456,
                    "enhanced": 7485
                },
                {
                    "maleAge": 70,
                    "femaleAge": 70,
                    "flexible": 7797,
                    "enhanced": 7853
                }
            ]
        },
        "cpi": {
            "male": {
                "60": [
                    5548,
                    5881
                ],
                "65": [
                    6061,
                    6537
                ],
                "70": [
                    6775,
                    7460
                ],
                "75": [
                    7833,
                    8815
                ]
            },
            "female": {
                "60": [
                    5329,
                    5522
                ],
                "65": [
                    5794,
                    6063
                ],
                "70": [
                    6428,
                    6843
                ],
                "75": [
                    7352,
                    8030
                ]
            },
            "reversionary": [
                {
                    "maleAge": 65,
                    "femaleAge": 60,
                    "flexible": 5261,
                    "enhanced": 5275
                },
                {
                    "maleAge": 65,
                    "femaleAge": 65,
                    "flexible": 5545,
                    "enhanced": 5570
                },
                {
                    "maleAge": 70,
                    "femaleAge": 65,
                    "flexible": 5729,
                    "enhanced": 5751
                },
                {
                    "maleAge": 70,
                    "femaleAge": 70,
                    "flexible": 6129,
                    "enhanced": 6172
                }
            ]
        }
    },
    "carePlus": {
        "male": {
            "70": 5790,
            "75": 5793,
            "80": 5805,
            "85": 5825,
            "90": 5849,
            "95": 5877,
            "100": 5907
        },
        "female": {
            "70": 5813,
            "75": 5801,
            "80": 5792,
            "85": 5791,
            "90": 5800,
            "95": 5819,
            "100": 5857
        }
    },
    "fixedTerm": {
        "rcv100": {
            "1": {
                "monthly": 5.46,
                "yearly": null
            },
            "2": {
                "monthly": 5.65,
                "yearly": 5.8
            },
            "3": {
                "monthly": 5.79,
                "yearly": 5.95
            },
            "4": {
                "monthly": 5.79,
                "yearly": 5.95
            },
            "5": {
                "monthly": 5.79,
                "yearly": 5.95
            },
            "6": {
                "monthly": 5.84,
                "yearly": 6
            },
            "10": {
                "monthly": 5.98,
                "yearly": 6.15
            },
            "15": {
                "monthly": 6.08,
                "yearly": 6.25
            },
            "20": {
                "monthly": 6.13,
                "yearly": 6.3
            }
        },
        "rcv0": {
            "1": {
                "monthly": 5.22,
                "yearly": null
            },
            "2": {
                "monthly": 5.46,
                "yearly": 5.6
            },
            "3": {
                "monthly": 5.65,
                "yearly": 5.8
            },
            "4": {
                "monthly": 5.79,
                "yearly": 5.95
            },
            "5": {
                "monthly": 5.79,
                "yearly": 5.95
            },
            "6": {
                "monthly": 5.79,
                "yearly": 5.95
            },
            "10": {
                "monthly": 5.89,
                "yearly": 6.05
            },
            "15": {
                "monthly": 5.98,
                "yearly": 6.15
            },
            "20": {
                "monthly": 6.03,
                "yearly": 6.2
            }
        }
    }
} as const;

export type AnnuityRateTable = typeof ANNUITY_RATES;
